module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ProductDetailView.js"));
	}, "ProductDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ProductDetailView!./src/pages/Shop/Product/ProductDetail/ProductDetailView.js
// module id = 874
// module chunks = 431